import React, { useEffect, useRef, useState } from "react";
import { Video } from "lucide-react";

const APP_ID = "vpaas-magic-cookie-5c9f5449e10f4849886de67799a2a81b";
const ROOM = "GiftOfKindnessMeeting";
const SCRIPT_SRC = `https://8x8.vc/${APP_ID}/external_api.js`;

const loadScript = () =>
    new Promise((resolve, reject) => {
        if (window.JitsiMeetExternalAPI) return resolve();
        const existing = document.querySelector(`script[src="${SCRIPT_SRC}"]`);
        if (existing) {
            existing.addEventListener("load", resolve);
            existing.addEventListener("error", reject);
            return;
        }
        const s = document.createElement("script");
        s.src = SCRIPT_SRC;
        s.async = true;
        s.onload = resolve;
        s.onerror = reject;
        document.head.appendChild(s);
    });

export default function Meeting() {
    const containerRef = useRef(null);
    const [status, setStatus] = useState("loading");

    useEffect(() => {
        let api;
        loadScript()
            .then(() => {
                if (!containerRef.current) return;
                api = new window.JitsiMeetExternalAPI("8x8.vc", {
                    roomName: `${APP_ID}/${ROOM}`,
                    parentNode: containerRef.current,
                    width: "100%",
                    height: "100%",
                });
                setStatus("ready");
            })
            .catch(() => setStatus("error"));
        return () => api?.dispose();
    }, []);

    return (
        <div data-testid="meeting-page">
            <section className="px-6 md:px-12 lg:px-20 pt-12 md:pt-16 pb-8 md:pb-10 flex flex-col md:flex-row md:items-end md:justify-between gap-6">
                <div>
                    <div className="eyebrow text-[#B8860B] mb-4">Live Video Room</div>
                    <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[0.95]">
                        Join Meeting
                    </h1>
                </div>
                <p className="text-base md:text-lg text-black/60 font-light max-w-md leading-relaxed">
                    Enter your name, turn on your camera and mic, and join the Gift of Kindness
                    community room.
                </p>
            </section>

            <section className="px-6 md:px-12 lg:px-20 pb-16 md:pb-24">
                <div
                    data-testid="meeting-frame-wrapper"
                    className="relative bg-[#0A0A0A] border border-black/10 h-[70vh] min-h-[520px] overflow-hidden"
                >
                    {status !== "ready" && (
                        <div
                            data-testid="meeting-status"
                            className="absolute inset-0 flex flex-col items-center justify-center gap-4 text-center px-6"
                        >
                            <Video size={32} strokeWidth={1.25} className="text-[#D4AF37]" />
                            <p className="font-serif text-2xl text-white/80">
                                {status === "error"
                                    ? "The meeting room couldn't load. Please refresh and try again."
                                    : "Preparing your meeting room…"}
                            </p>
                        </div>
                    )}
                    <div ref={containerRef} data-testid="jaas-container" className="w-full h-full" />
                </div>
            </section>
        </div>
    );
}
